// Compression d'image côté client avec horodatage burn-in (timestamp tamper-proof) :
// redimensionnement, JPEG, date/heure gravée en bas à droite.
//
// LA DATE D'AJOUT FAIT FOI, ET ELLE EST DANS L'IMAGE (Boubacar, 26/10 puis 27/10). Elle
// voyage donc avec la photo partout où celle-ci circule : vue distributeur, téléchargement,
// pièce jointe. Photos d'installation et photos d'étiquettes (lot L5) passent par la même
// gravure, pour qu'aucune des deux familles ne se date autrement que l'autre. Chaque
// appelant garde sa résolution : 1024 px suffisent à une photo de pose, une étiquette doit
// rester lisible (voir `PhotoSerialCapture`).

const pad = (n) => String(n).padStart(2, '0');

// Grave « jj/mm/aaaa hh:mm » (heure locale de l'appareil, celle que le poseur lit sur son
// téléphone) dans un bandeau semi-opaque en bas à droite du canvas.
export function graverDateAjout(ctx, width, height, date) {
  const stamp = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  const fontSize = Math.max(14, Math.round(width / 40));
  ctx.font = `${fontSize}px Helvetica, Arial, sans-serif`;
  ctx.textBaseline = 'bottom';
  const padX = 10;
  const padY = 8;
  const textW = ctx.measureText(stamp).width;
  // Bandeau semi-opaque
  ctx.fillStyle = 'rgba(0, 0, 0, 0.55)';
  ctx.fillRect(
    width - textW - padX * 2 - 6,
    height - fontSize - padY * 2,
    textW + padX * 2 + 6,
    fontSize + padY * 2
  );
  // Texte blanc
  ctx.fillStyle = '#ffffff';
  ctx.fillText(stamp, width - textW - padX - 3, height - padY);
}

// La date gravée et `taken_at` viennent du MÊME instant : deux `new Date()` pourraient
// tomber de part et d'autre d'une minute, et l'image contredirait la donnée enregistrée.
export async function compressImage(file, maxDim = 1024, quality = 0.8) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxDim || height > maxDim) {
          if (width > height) {
            height = Math.round(height * (maxDim / width));
            width = maxDim;
          } else {
            width = Math.round(width * (maxDim / height));
            height = maxDim;
          }
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        const now = new Date();
        graverDateAjout(ctx, width, height, now);
        resolve({
          data: canvas.toDataURL('image/jpeg', quality),
          taken_at: now.toISOString(),
        });
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
